/** @jsxImportSource theme-ui */
import { Typography } from '../../Typography';

const BdBetaPill = () => {
  return (
    <Typography
      variant="caption2"
      color="white"
      marginBottom="0"
      inline
      sx={{
        backgroundColor: t => `${t.colors.seafoam100} !important`,
        padding: '4px',
        borderRadius: '4px',
        margin: 'auto 0 auto 8px',
      }}
    >
      Beta
    </Typography>
  );
};

export default BdBetaPill;
